module.exports = __webpack_public_path__ + "img/listing.df2a5c5f.svg";